var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.7431C0 19.4678 0.746725 19.9518 1.40824 19.656L20.9587 10.9129C21.7477 10.5601 21.7477 9.44004 20.9587 9.08719L1.40824 0.344129C0.746727 0.0482956 0 0.53235 0 1.257V7.71435L9.70864 9.00884C10.8658 9.16312 10.8658 10.837 9.70865 10.9913L0 12.2858V18.7431Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/sendMessage.eeed0b90.svg";
export { ForwardRef as ReactComponent };